var render = function (_h,_vm) {var _c=_vm._c;return _c('section',{class:['crm-block', _vm.data.staticClass],style:({
    'box-shadow': ("0px 2px 10px 0px " + (_vm.props.backgroundColor || '#FFF')),
    'background-color': _vm.props.backgroundColor,
    'background-image': ("url(" + (_vm.props.backgroundImage) + ")"),
    'background-size': '100% 100%',
  })},[_c('div',{staticClass:"crm-block_tip"},[_c('img',{attrs:{"width":"20","height":"20","src":_vm.props.tipIcon,"alt":"icon"}}),_c('span'),_c('span',[_vm._v(_vm._s(_vm.props.tipText))])]),_c('div',{staticClass:"crm-block_theme"},[_c('strong',[_vm._v(_vm._s(_vm.props.theme))])])])}
var staticRenderFns = []

export { render, staticRenderFns }